import { FilterParams } from '@synergy/models';
import { FormattedMessage } from 'react-intl';
import { ReactElement } from 'react';

import { FilterToggle, FilterToggleProps } from '../../../../components/filter';

export const BestPriceFilter = (props: Partial<FilterToggleProps>): ReactElement => {
    return (
        <FilterToggle
            {...props}
            sx={{ flex: 1 }}
            filterParam={FilterParams.BestPrice}
            label={<FormattedMessage id="app.filter.bestprice" />}
        />
    );
};
